export const PACKAGE_VERSION = "24.9.1"
